<template>
  <v-dialog v-model="dialog" persistent max-width="290" content-class="gift-dialog" overlay-opacity="0.9">
    <v-card color="transparent" class="d-flex flex-column justify-center align-center pa-3 white--text"
      v-if="beforeClicked" @click="claim">
      <v-progress-circular v-if="api.isLoading" size="100" width="10" indeterminate color="white"></v-progress-circular>
      <v-img v-else width="200" contain class="zoom-in-out-box"
        :src="require('@/assets/explore/CompletionGift1.png')"></v-img>
      {{ $t("action.clickToClaim") }}
    </v-card>
    <RewardDialog v-else-if="afterClicked" :callbackClose="callbackClose" :showDialog="true" :rewards="rewards" />
  </v-dialog>
</template>

<script>
export default {
  components: {
    RewardDialog: () =>
      import(
        /* webpackChunkName: "component-reward" */ "@/components/games/RewardDialog"
      ),
  },
  props: {
    callback: {
      type: Function,
      default: () => {},
    },
    callbackClose: {
      type: Function,
      required: true,
    },
    totalCoins: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    dialog: true,
    beforeClicked: true,
    afterClicked: false,
    rewards: [],
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
  }),
  mounted() {
    this.rewards = [
      {
        Item: {
          images: {
            icon: {
              url: require("@/assets/explore/coin.png"),
            },
          },
        },
        quantity: this.totalCoins,
      },
    ];
  },
  methods: {
    async claim() {
      await this.addCoin();
    },
    async addCoin() {
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/item/updateMany";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
      };

      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
        console.error("Failed to award coins:", e);
      };

      this.api.callbackSuccess = () => {
        this.callback();
        this.api.isLoading = false;
        this.beforeClicked = false;
        this.afterClicked = true;
      };
      this.api.params = {
        data:
          '[{"action":"add","itemKey":"goldcoin","quantity":' +
          this.totalCoins +
          '}]',
      };
      await this.$api.fetch(this.api);
    },
  },
};
</script>

<style scoped>
.zoom-in-out-box {
  animation: zoom-in-zoom-out 2s ease infinite;
}

.gift-dialog {
  box-shadow: none;
}

@keyframes zoom-in-zoom-out {
  0% {
    transform: scale(1, 1);
  }

  50% {
    transform: scale(1.1, 1.1);
  }

  100% {
    transform: scale(1, 1);
  }
}
</style>
